import React from 'react';
import {
  Box,
  Typography,
  ButtonBase
} from '@mui/material';

import { useNavigate } from 'react-router-dom';

import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

interface HomePageProps {
  isMenuOpen?: boolean;
}

export default function HomePage({
  isMenuOpen = false
}: HomePageProps) {

  const navigate = useNavigate();

  return (
    <GridLayout
      isMenuOpen={isMenuOpen}

      left={<Menu />}

      main={
        <Card>

          {/* Title */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              lineHeight: 1.1,
              textAlign: 'center',
            }}
          >
            Everyday Little Practices
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: '#34de9aab',
              fontWeight: 700,
              lineHeight: 1.1,
              textAlign: 'center',
              mb: 4
            }}
          >
            Everyday More Happiness
          </Typography>

          {/* CLICKABLE MASCOT AREA */}
          <ButtonBase
            onClick={() => navigate('/session')}
            sx={{
              width: '100%',
              borderRadius: 4,
              overflow: 'hidden',
              display: 'block'
            }}
          >

            <Box
              sx={{
                mt: 2,
                minHeight: 320,
                bgcolor: 'white',
                borderRadius: 4,

                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',

                transition: '0.3s',

                '&:hover': {
                  transform: 'scale(1.01)',
                  bgcolor: '#f0fdf8'
                }
              }}
            >

              {/* Mascot */}
              <Box
                component="img"
                src="/images/mascot.png"
                alt="Here Mai Mai Mascot"
                sx={{
                  width: {
                    xs: 220,
                    sm: 280,
                    md: 340
                  },

                  maxWidth: '80%',
                  objectFit: 'contain',

                  transition: '0.3s',

                  '&:hover': {
                    transform: 'scale(1.03)'
                  }
                }}
              />

              {/* CTA */}
              <Typography
                variant="h5"
                sx={{
                  mt: 3,
                  fontWeight: 'bold',
                  color: '#34de9aab'
                }}
              >
                Start Pilates Session
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  color: 'white'
                }}
              >
                Enter Posture Analysis Clips
              </Typography>

            </Box>

          </ButtonBase>

        </Card>
      }

      right={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >

          {/* Right Card */}
          <Card>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                mb: 2
              }}
            >
              Posture for Today
            </Typography>

            <Box
              component="img"
              src="/images/10.JPG"
              alt="Posture"
              sx={{
                width: '100%',
                borderRadius: 3
              }}
            />

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: 'gray'
              }}
            >
              Relax and close your eyes. Massage scalp and ears with your fingers.
            </Typography>

          </Card>

          {/* Mini CTA */}
          <Card>

            <Typography
              variant="h6"
              sx={{
                color: '#34de9aab',
                fontWeight: 'bold'
              }}
            >
              HERE MAI MAI
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 1 }}
            >
              Pilates Customized with AI + IoT Wellness Platform
            </Typography>

          </Card>

        </Box>
      }
    />
  );
}